import React from "react";
import { Spinner } from "react-bootstrap";
import "./ConnectProviderCards.css";

export const FITBIT_ANDROID_INSTRUCTIONS_URL =
  "https://docs.google.com/document/d/1Pd8EwEY6lehq759tdT1a2OWyuZyxT9W1DItCqq4SuMc/edit?usp=sharing";
export const FITBIT_IPHONE_INSTRUCTIONS_URL =
  "https://docs.google.com/document/d/1m63aMt-3tdCVHByY6qCb-tD954OlmFedpDxuZy6PQt4/edit?usp=sharing";
const IOS_APP_URL = "https://apps.apple.com/ca/app/my-challenge-canada/id6796786475";

// Simple brand marks drawn inline so no image files are needed.
const FitbitLogo = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    {[
      [12, 3, 1.4],
      [12, 7.5, 1.7],
      [12, 12, 2],
      [12, 16.5, 1.7],
      [12, 21, 1.4],
      [7.5, 7.5, 1.4],
      [7.5, 12, 1.7],
      [7.5, 16.5, 1.4],
      [3, 12, 1.4],
      [16.5, 12, 1.7],
      [16.5, 7.5, 1.4],
      [16.5, 16.5, 1.4],
      [21, 12, 1.4],
    ].map(([cx, cy, r]) => (
      <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} fill="currentColor" />
    ))}
  </svg>
);

const GarminLogo = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 3 L22 20 H2 Z" fill="currentColor" />
  </svg>
);

const StravaLogo = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"
    />
  </svg>
);

const AppleLogo = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
    />
  </svg>
);

const Card = ({ variant, logo, name, note, children }) => (
  <div className={`cpc-card cpc-${variant}`}>
    <div className="cpc-head">
      <span className="cpc-logo">{logo}</span>
      <span className="cpc-name">{name}</span>
    </div>
    {note && <p className="cpc-note">{note}</p>}
    <div className="cpc-actions">{children}</div>
  </div>
);

const ConnectProviderCards = ({ garminConnectEnabled, onGarminConnect, stravaOpen, onStravaToggle, onStravaInfo }) => (
  <section className="cpc" aria-label="Connect an activity tracker">
    <h3 className="cpc-title">Connect your activity</h3>
    <div className="cpc-grid">
      <Card variant="fitbit" logo={<FitbitLogo />} name="Fitbit" note="Also Google Health. Setup steps:">
        <a className="cpc-btn" href={FITBIT_IPHONE_INSTRUCTIONS_URL} target="_blank" rel="noopener noreferrer">
          iPhone
        </a>
        <a className="cpc-btn" href={FITBIT_ANDROID_INSTRUCTIONS_URL} target="_blank" rel="noopener noreferrer">
          Android
        </a>
      </Card>
      <Card variant="garmin" logo={<GarminLogo />} name="Garmin" note="Sync from Garmin Connect">
        <button type="button" className="cpc-btn" disabled={!garminConnectEnabled} onClick={onGarminConnect}>
          Connect
          {!garminConnectEnabled && <Spinner className="ml-1" size="sm" />}
        </button>
      </Card>
      <Card variant="strava" logo={<StravaLogo />} name="Strava" note="Works with most watches">
        <button type="button" className="cpc-btn" aria-expanded={stravaOpen} onClick={onStravaToggle}>
          {stravaOpen ? "Hide" : "Connect"}
        </button>
        <button type="button" className="cpc-btn cpc-btn-round" aria-label="Learn about using Strava for free" onClick={onStravaInfo}>
          i
        </button>
      </Card>
      <Card variant="apple" logo={<AppleLogo />} name="Apple Watch" note="Through Apple Health">
        <a className="cpc-btn" href={IOS_APP_URL} target="_blank" rel="noreferrer">
          Get the iOS app
        </a>
      </Card>
    </div>
  </section>
);

export default ConnectProviderCards;
